import { GetBuildingHistoryReq, GetBuildingHistoryRes } from '@gateway.Building'
import { yamadumiApi } from '../yamadumi-api'

export class HistoryListGateway {
  static getBuildingHistoryList = async (params: GetBuildingHistoryReq) => {
    const {
      procurementNo,
      subNo
    } = params
    return await yamadumiApi.get<GetBuildingHistoryRes['buildingInfoList']>(
      '/api/building/item/history/list',
      { procurementNo, subNo }
    )
  }
}
